import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {BruteForce} from "../BruteForce";
import {BruteForceSound} from "../sound/BruteForceSound";

export class BruteForceTransitionScreen extends PIXI.Container implements StageLayer {

    private _button: ContinueButton;
    private clickCallback?: Function;


    private init(): void {
        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.pivot.set(this._button.width * 0.5, 0);
        this._button.enable(false);
        this._button.alpha = 0;

        this.visible = false;
        this.addChild(this._button);

    }

    constructor() {
        super();
        this.name = "TransitionScreen";
        this.init();
    }


    private onButtonClick() {
        this._button.enable(false);
        if (this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        BruteForceSound.playTrack(BruteForceSound.CONTINUE_BUTTON);
        gsap.to(this._button, {duration: 0.2, alpha: 0});
        this.visible = false;
        delete this.clickCallback;
    }

    public onResize(): void {
        if (!this.visible) {
            return;
        }
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            if (!BruteForce.model.brokeTheBank) {
                this._button.position.set(360, 580);
            } else {
                this._button.position.set(360, 604);
            }
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 565;
            this._button.position.set(360, centerBottom - 80);
        }
    }


    public enableButton(cb: Function): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = cb;
            this._button.enable(true);
            this.visible = true;
            this.onResize();
        });

        tl.to([this._button], {
            alpha: 1,
            duration: 0.3
        });
        tl.add(() => {
            this._button.enable(true)
        });

        return tl;
    }


}